<template>
  <div>
    <vg-card v-for="applicantForm in value" :key="JSON.stringify(applicantForm)">
      <vg-view-field-list class="space-between">
        <dp-application-view-field
            v-for="field in applicantForm.fields"
            :key="field.applicationAttributeFieldId"
            :value="field"
            maximum
        />
      </vg-view-field-list>
    </vg-card>
  </div>
</template>

<script>
import VgCard from '@/components/Commons/VgCard';
import DpApplicationViewField from './DpApplicationViewField';
import VgViewFieldList from "@/components/Commons/VgViewFieldList.vue";

export default {
  name: "ApplicantList",
  components: {VgViewFieldList, DpApplicationViewField, VgCard},
  props: {
    value: Array
  }
}
</script>

<style scoped>

</style>